import { render } from "./g-datetime-edit.vue?vue&type=template&id=b901ae82&ts=true"
import script from "./g-datetime-edit.vue?vue&type=script&lang=tsx"
export * from "./g-datetime-edit.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__